import { createContext, useContext, useEffect, useState } from "react";

export const SECTIONS = [
  { id: "rajasthan", en: "Rajasthan", hi: "राजस्थान" },
  { id: "national", en: "National", hi: "देश" },
  { id: "international", en: "International", hi: "विदेश" },
  { id: "politics", en: "Politics", hi: "राजनीति" },
  { id: "business", en: "Business", hi: "बिज़नेस" },
  { id: "sports", en: "Sports", hi: "खेल" },
  { id: "entertainment", en: "Entertainment", hi: "मनोरंजन" },
  { id: "tech", en: "Tech", hi: "टेक" },
  { id: "lifestyle", en: "Lifestyle", hi: "लाइफस्टाइल" },
  { id: "viral", en: "Viral", hi: "वायरल" },
];

export const DISTRICTS = [
  { id: "jaipur", en: "Jaipur", hi: "जयपुर" },
  { id: "jodhpur", en: "Jodhpur", hi: "जोधपुर" },
  { id: "udaipur", en: "Udaipur", hi: "उदयपुर" },
  { id: "bikaner", en: "Bikaner", hi: "बीकानेर" },
  { id: "jaisalmer", en: "Jaisalmer", hi: "जैसलमेर" },
  { id: "ajmer", en: "Ajmer", hi: "अजमेर" },
  { id: "kota", en: "Kota", hi: "कोटा" },
  { id: "alwar", en: "Alwar", hi: "अलवर" },
  { id: "sikar", en: "Sikar", hi: "सीकर" },
  { id: "bhilwara", en: "Bhilwara", hi: "भीलवाड़ा" },
  { id: "barmer", en: "Barmer", hi: "बाड़मेर" },
  { id: "churu", en: "Churu", hi: "चुरू" },
  { id: "jhunjhunu", en: "Jhunjhunu", hi: "झुंझुनू" },
  { id: "pali", en: "Pali", hi: "पाली" },
  { id: "nagaur", en: "Nagaur", hi: "नागौर" },
  { id: "bharatpur", en: "Bharatpur", hi: "भरतपुर" },
  { id: "banswara", en: "Banswara", hi: "बांसवाड़ा" },
  { id: "baran", en: "Baran", hi: "बारां" },
  { id: "bundi", en: "Bundi", hi: "बूंदी" },
  { id: "chittorgarh", en: "Chittorgarh", hi: "चित्तौड़गढ़" },
  { id: "dausa", en: "Dausa", hi: "दौसा" },
  { id: "dholpur", en: "Dholpur", hi: "धौलपुर" },
  { id: "dungarpur", en: "Dungarpur", hi: "डूंगरपुर" },
  { id: "hanumangarh", en: "Hanumangarh", hi: "हनुमानगढ़" },
  { id: "jalore", en: "Jalore", hi: "जालोर" },
  { id: "jhalawar", en: "Jhalawar", hi: "झालावाड़" },
  { id: "karauli", en: "Karauli", hi: "करौली" },
  { id: "pratapgarh", en: "Pratapgarh", hi: "प्रतापगढ़" },
  { id: "rajsamand", en: "Rajsamand", hi: "राजसमंद" },
  { id: "sawai-madhopur", en: "Sawai Madhopur", hi: "सवाई माधोपुर" },
  { id: "sirohi", en: "Sirohi", hi: "सिरोही" },
  { id: "sri-ganganagar", en: "Sri Ganganagar", hi: "श्रीगंगानगर" },
  { id: "tonk", en: "Tonk", hi: "टोंक" },
  { id: "balotra", en: "Balotra", hi: "बालोतरा" },
  { id: "beawar", en: "Beawar", hi: "ब्यावर" },
  { id: "deeg", en: "Deeg", hi: "डीग" },
  { id: "didwana-kuchaman", en: "Didwana-Kuchaman", hi: "दीदवाना-कुचामन" },
  { id: "kotputli-behror", en: "Kotputli-Behror", hi: "कोटपूतली-बहरोर" },
  { id: "khairthal-tijara", en: "Khairthal-Tijara", hi: "खैरथल-टिजारा" },
  { id: "phalodi", en: "Phalodi", hi: "फलोदी" },
  { id: "salumbar", en: "Salumbar", hi: "सलूंबर" },
];

const STR = {
  hi: {
    home: "मुख्य पृष्ठ",
    tagline: "सत्य • निष्पक्षता • निर्भीकता",
    edition: "जैसलमेर संस्करण",
    latest: "ताज़ा ख़बरें",
    trending: "चर्चा में",
    opinion: "विचार",
    breaking: "ब्रेकिंग",
    seeAll: "सभी देखें",
    searchPlaceholder: "ख़बर खोजें...",
    searchTitle: "खोज परिणाम",
    noResults: "कोई ख़बर नहीं मिली",
    readFull: "पूरी ख़बर पढ़ें",
    related: "यह भी पढ़ें",
    share: "साझा करें",
    copied: "लिंक कॉपी हो गया",
    minRead: "मिनट में पढ़ें",
    topStory: "बड़ी ख़बर",
    loadError: "ख़बरें लोड नहीं हो पाईं",
    all: "सभी",
    stories: "ख़बरें",
    epaper: "ई-पेपर",
    epaperSub: "आज का अख़बार — पढ़ें, प्रिंट करें, साझा करें",
    printDownload: "प्रिंट / PDF डाउनलोड",
    noEdition: "इस दिन की कोई ख़बर उपलब्ध नहीं",
  },
  en: {
    home: "Home",
    tagline: "Truth • Integrity • Courage",
    edition: "Jaisalmer Edition",
    latest: "Latest News",
    trending: "Trending",
    opinion: "Opinion",
    breaking: "BREAKING",
    seeAll: "View all",
    searchPlaceholder: "Search news...",
    searchTitle: "Search Results",
    noResults: "No stories found",
    readFull: "Read full story",
    related: "Also read",
    share: "Share",
    copied: "Link copied",
    minRead: "min read",
    topStory: "Top Story",
    loadError: "Could not load news",
    all: "All",
    stories: "stories",
  },
};

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lok_lang") || "hi");
  useEffect(() => {
    localStorage.setItem("lok_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: STR[lang] }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}

export const pickTitle = (a, lang) => (lang === "en" && a.title_en ? a.title_en : a.title);
export const pickSummary = (a, lang) => (lang === "en" && a.summary_en ? a.summary_en : a.summary);
export const pickBody = (a, lang) => (lang === "en" && a.body_en ? a.body_en : a.body) || a.summary || "";

export const imgSrc = (u) =>
  !u ? "" : u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

export function formatIST(iso, lang) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(lang === "hi" ? "hi-IN" : "en-IN", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function timeAgo(iso, lang) {
  const diff = Date.now() - new Date(iso).getTime();
  const h = Math.floor(diff / 3.6e6);
  if (h < 1) return lang === "hi" ? "अभी-अभी" : "Just now";
  if (h < 24) return lang === "hi" ? `${h} घंटे पहले` : `${h}h ago`;
  const d = Math.floor(h / 24);
  return lang === "hi" ? `${d} दिन पहले` : `${d}d ago`;
}

export function readMins(text) {
  return Math.max(1, Math.round((text || "").split(/\s+/).length / 200));
}

export function formatDate(iso, lang) {
  return new Date(iso).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
